import ApiClient from '../../services/ApiClient2';

let credentialsCancelToken = undefined;

export function getCredentials() {
    if (undefined !== credentialsCancelToken) {
        credentialsCancelToken.cancel();
    }

    credentialsCancelToken = ApiClient.createCancelToken();

    return ApiClient.query(`/credentials/user`, {}, {
        cancelToken: credentialsCancelToken.token
    }).then(({data}) => {
        credentialsCancelToken = undefined;

        return {data};
    });
}

export function createCredentials(params) {
    return ApiClient.post(`/credentials/user`, params);
}

export function updateCredentials(uuid, params) {
    return ApiClient.patch('/credentials', uuid, params);
}